import { IAction } from '@/interface/IAction';

export const actionType = Object.freeze({
    CREATE_FUNDER_STATEMENT: 'report.create-funder-statement',
    SET_PRE_SIGNED_FUNDER_STATEMENT_URL: 'report.set-pre-signed-funder-statement-url',
});

export function createFunderStatement(
    beginDate,
    endDate,
    balanceOffsetUSD,
    balanceOffsetHKD,
    creator,
    setIsSendingCreateFunderStatementRequest,
): IAction {
    const payload = {
        beginDate,
        endDate,
        balanceOffsetUSD,
        balanceOffsetHKD,
        creator,
        setIsSendingCreateFunderStatementRequest,
    };
    return {
        type: actionType.CREATE_FUNDER_STATEMENT,
        payload,
    }
}

export function setPreSignedFunderStatementUrl(url: string): IAction {
    return {
        type: actionType.SET_PRE_SIGNED_FUNDER_STATEMENT_URL,
        payload: url
    }
}